import { useAnimationFrame } from "motion/react";
/*
 변경속도 비율 : 작을수록 천천히 & 부드럽게 변경
 */
const SOFT_SCROLL_RATIO = 0.7;

export const useSmoothAnimationFrame = ({
  smoothIndex,
  images,
  drawImageCb,
}) => {
  let displayIndex = 0; // 현재 표시 중인 인덱스
  let lastUpdate = 0;
  // 리렌더 시 지역변수가 리셋되므로(-1) 리사이즈 등으로 캔버스가 지워져도 다음 틱에 다시 그려진다
  let lastDrawnIndex = -1;
  const throttleDelay = 30; // 30ms 간격으로 업데이트 (~33fps)

  useAnimationFrame((time) => {
    if (time - lastUpdate < throttleDelay) return;
    lastUpdate = time;

    const targetIndex = smoothIndex.get();
    displayIndex += (targetIndex - displayIndex) * SOFT_SCROLL_RATIO;

    const index = Math.floor(
      Math.min(Math.max(1, displayIndex), images.length - 1),
    );

    // 인덱스가 그대로면 캔버스 재드로우 스킵 (정지 상태의 매 프레임 전체 재드로우 제거)
    if (index === lastDrawnIndex) return;

    // drawImageOnCanvas 는 미로드 이미지에서 no-op 이므로, 로드 확인 전에 latch 하면
    // 해당 인덱스가 영영 빈 캔버스로 남는다 — 로드된 경우에만 latch 하고 아니면 재시도
    const image = images[index];
    if (!image || !image.complete || image.naturalWidth === 0) return;

    lastDrawnIndex = index;
    drawImageCb(index);
  });
};
